export const types = {
  setLoadingStatus: "[loadingAction] setLoadingStatus",
  setCalculing: "[loadingAction] setCalculing",
  setLoginErr: "[authErrAcion] setLoginErr",
  storeUserData: "[loginAcion] storeUserData",
  setLogged: "[loginAcion] setLogged",
  setElAguilaAuth: "[asistenciasActions] setElAguilaAuth",

  setRegisterDeviceErr: "[authErrAcion] setRegisterDeviceErr",
  setBrowserAllowed: "[loginAcion] setBrowserAllowed",

  storeProveedoresApi: "[asistencias actions] storeProveedoresApi",
  setEnviandoProveedorApi: "[asistencias actions] setEnviandoProveedorApi",

  //// notificaciones
  notification: "[notificacionAction] notification",
  storeVersionBackend: "[notificacionAction] storeVersionBackend",

  setEstatusAsistencia: "[detalleActions] setEstatusAsistencia",
  ///
  storeClientes: "[clientesActions] storeClientes",

  //////// errores
  setErrBuscaValidador: "[erroresActions] setErrBuscaValidador",
  cleanErroresBuscaValidador: "[erroresActions] cleanErroresBuscaValidador",

  //

  // asistencias

  storeClientesCampanias: "[capturaActions] storeClientesCampanias",
  setCaptura: "[capturaActions] setCaptura",
  setCapturaStep: "[capturaActions] setCapturaStep",
  setCapturaCampos: "[capturaActions] setCapturaCampos",
  storeServicios: "[capturaActions] storeServicios",
  storeValidadorInfo: "[capturaActions] storeValidadorInfo",
  cleanCaptura: "[capturaActions] cleanCaptura",

  setNewLatLng: "[capturaActions] setNewLatLng",
  setEsperandoSMS: "[capturaActions] setEsperandoSMS",
  storeAsistenciaID: "[capturaActions] storeAsistenciaID",

  // Mapa
  setGeoDataOrigen: "[capturaActions] setGeoDataOrigen",

  /// detalle
  setLoadingDatosDrawer: "[detalleActions] setLoadingDatosDrawer",
  storeCorralones: "[detalleActions] storeCorralones",
  storeTalleres: "[detalleActions] storeTalleres",
  setFolderPagina: "[detalleActions] setFolderPagina",
  setAsistenciaDetalle: "[detalleActions] setAsistenciaDetalle",
  storeAsistencia: "[detalleActions] storeAsistencia",
  storeAceptacionNotificacion: "[detalleActions] storeAceptacionNotificacion",
  clearAceptacionNotificacion: "[detalleActions] clearAceptacionNotificacion",
  setLoadingDetalle: "[detalleActions] setLoadingDetalle",
  storeSucursalesByServicio: "[detalleActions] storeSucursalesByServicio",
  setProveedorGeos: "[detalleActions] setProveedorGeos",
  clearProveedorGeos: "[detalleActions] clearProveedorGeos",

  storeProveedorCostos: "[detalleActions] storeProveedorCostos",
  setProveedorPagoDirecto: "[detalleActions] setProveedorPagoDirecto",
  storeHistorialAsignacion: "[detalleActions] storeHistorialAsignacion",
  storeAsistenciaHistorial: "[detalleActions] storeAsistenciaHistorial",
  clearProveedorCostos: "[detalleActions] clearProveedorCostos",
  storeAsistenciaFiles: "[detalleActions] storeAsistenciaFiles",

  setLoadingHistorialAsignacion: "[detalleActions] setLoadingHistorialAsignacion",
  // servicios
  storeAsistenciasByValidador1:
    "[asistenciasActions] storeAsistenciasByValidador1",
  storeServiciosByMes: "[asistenciasActions] storeServiciosByMes",

  storeMisServicios: "[asistenciasActions] storeMisServicios",

  setFiltroAsistencia: "[asistenciasActions] setFiltroAsistencia",

  /// GNP API
  storeSiniestro: "[gnpApiActions] storeSiniestro",
  storeSiniestros: "[gnpApiActions] storeSiniestros",
  storeEstatusList: "[gnpApiActions] storeEstatusList",
  setUltimaVerificacion: "[gnpApiActions] setUltimaVerificacion",
  storeCatServiciosGNP: "[gnpApiActions] storeCatServiciosGNP",

  //// Semaforo
  setFiltrosVisorAsignacion: "[semaforoActions] setFiltrosVisorAsignacion",
  setFiltrosVisorSeguimiento: "[semaforoActions] setFiltrosVisorSeguimiento",

  //// Polizario
  // El aguila
  storeElAguilaLista: "[polizarioActions] storeElAguilaLista",
  storeElAguilaPoliza: "[polizarioActions] storeElAguilaPoliza",
  storeChubbPoliza: "[polizarioActions] storeChubbPoliza",
  setClienteID: "[polizarioActions] setClienteID",
  setLoadingPolizario: "[polizarioActions] setLoadingPolizario",
  setVistaResultados: "[polizarioActions] setVistaResultados",

  // qualitas
  setQualitasResponse: "[polizarioActions] setQualitasResponse",

  // GSeguros
  setGSegurosResponse: "[polizarioActions] setGSegurosResponse",
  setGSegurosEmision: "[polizarioActions] setGSegurosEmision",
  setLoadingGSeguros: "[polizarioActions] setLoadingGSeguros",
  setVistaGSeguros: "[polizarioActions] setVistaGSeguros",
  cleanGSegurosEmision: "[polizarioActions] cleanGSegurosEmision",

  // Edega
  setEdegaContrato: "[polizarioActions] setEdegaContrato",
  setEdegaDetalleReclamo: "[polizarioActions] setEdegaDetalleReclamo",
  setLoadingEdega: "[polizarioActions] setLoadingEdega",
  setVistaEdega: "[polizarioActions] setVistaEdega",
  cleanPolizario: "[polizarioActions] cleanPolizario",

  //Chat
  setConnection: "[chat] setConnection",
  setCarreteros: "[carreteroActions] setCarreros",
  setConnectionProveedores: "[proveedoresActivos] setProveedoresActivos",

  // Desglose de costos
  setCostos: "[costosActions] setCostos",
  toggleModalLibrary: "[libraryPdf] openModalLibrary",
  saveHdiDetailsService: "[hdiActions] saveHdiDetailsService",
  saveHDIFieldsToCapture: "[hdiActions] saveFieldsToCapture",

  // Library

  saveConditions: "[conditionsActions] getConditions",
  setPDFInScreen: "[libraryPDF] setPDFInScreen",
  setCurrentPDFId: "[libraryPDF] setCurrentPDFId",
  openModalMain: "[libraryPDF] openModalMain",
  setCurrentUrlPDF: "[libraryPDF] setCurrentUrlPDF",
  saveMinimezedFiles: "[libraryPDF] saveMinimezedFiles",
  removeMinimizedFile: "[libraryPDF] removeMinimizedFile",
  changeValidationVersion: "[appReduer] changeValidVersion",
  showModalValidVersion: "[appReduer] showModal",
  saveDistance: " [detalleReducer] saveDistance ",

  // Seguimiento
  storeActividades: " [detalleReducer] storeActividades ",
  storeIncidencias: " [detalleReducer] storeIncidencias ",

  // propuestas de proveedor para carretero
  storePropuestas: " [detalleReducer] storePropuestas ",

  // proveedores Activos
  storeProveedoresActivos: " [proveedoresActivosReducer] storeProveedoresActivos ",

  
};
